import React, { useEffect, useState } from "react";
import "./Repository.css";
import { Form, FormGroup, Input } from "reactstrap";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { decryptData } from "../../utils/helper";
import { failed, success } from "../../utils/Tostify";
import { getPatientById, getPatientDocuments, updatePatientProfile, uploadOrUpdateDocument } from "../../api/patient";
import { decryptPatientData } from "../../utils/common";
import Loader from "../../components/Loader/Loader";
import moment from "moment";
import { handleFileUpload } from "../../utils/ImageToBase64";
import { getDocumentsByPateientId, updateApplicationReceipt } from "../../api/Applications";
import CustomPagination from "../../components/Pagination/CustomPagination";
import { ITEMS_PER_PAGE } from "../../utils/constants";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

function Repository() {
    const [open, setOpen] = useState('1');
    const [isLoading, setIsLoading] = useState(false);
    const [documents, setDocuments] = useState([]);
    const [receipts, setReceipts] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredDocuments, setFilteredDocuments] = useState([]);
    const [filteredReceipts, setFilteredReceipts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const dispatch  = useDispatch();
    let token = useSelector((state) => state.userReducer.token);
    let user = useSelector(state => state.userReducer.user);

    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };
    // State to keep track of active tab
    const [activeTab, setActiveTab] = useState('1');

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            setSearchQuery('');
            setCurrentPage(1);
        }
    };

    const getPatientDocument = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getPatientDocuments({ dispatch, token, id: user?._id, userId : user?._id });
            const responseData = decryptData(res.data);
            if (res?.status === "SUCCESS") {
                setDocuments(responseData);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    const getApplicationDocuments = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getDocumentsByPateientId({ dispatch, token, patientId: user._id });
            const responseData = res?.data;
            if (res?.status === "SUCCESS") {
            setReceipts(responseData);
            setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    useEffect(()=>{
		getPatientDocument();
        getApplicationDocuments();
	},[]);

    const handleDownload = (url) =>{
        window.open(url, "_blank");
    };

    const handleDocumentUpload = async (docId) => {
    // Create a file input dynamically
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".pdf,.doc,.docx"; // Accept specific file types if needed
    let base64pdfForm= "";
    let res;
    // Handle the file selection
    fileInput.onchange = async (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
        try {
            setIsLoading(true);
            base64pdfForm = await handleFileUpload(selectedFile);
            const fileExtension = selectedFile?.type?.split("/")[1];

            const filePayload = {
            base64String: base64pdfForm,
            extension: fileExtension,
            name: selectedFile?.name,
            userId: user?._id
            };
            // Call the API to upload or update the document
            const res = await uploadOrUpdateDocument({
            values: {file:filePayload},
            dispatch,
            token,
            patientId: user?._id,
            documentId: docId
            });

            if (res?.status === "SUCCESS") {
            success(res?.message); // Show success message
            getPatientDocument(); // Refresh the data if needed
            setIsLoading(false);
            } else {
            failed(res?.message); // Show error message
            setIsLoading(false);
            }
        } catch (error) {
            console.error("File upload error:", error);
            failed("File upload failed.");
            setIsLoading(false);
        }
        }
    };

    // Programmatically click the file input to open the file dialog
    fileInput.click();
    };

    const handleReceiptUpload = async (receipt) => {
    // Create a file input dynamically
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".pdf,.doc,.docx"; // Accept specific file types if needed
    let base64pdfForm= "";
    let res;
    // Handle the file selection
    fileInput.onchange = async (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
        try {
            base64pdfForm = await handleFileUpload(selectedFile);
            const fileExtension = selectedFile?.type?.split("/")[1];

            const filePayload = {
            base64String: base64pdfForm,
            extension: fileExtension,
            name: selectedFile?.name,
            userId: user?._id
            };
            // Call the API to upload or update the document
            const res = await updateApplicationReceipt({
            values: {receiptFile:filePayload},
            dispatch,
            token,
            applicationId: receipt?.applicationId,
            receiptId: receipt?._id
            });

            if (res?.status === "SUCCESS") {
            success(res?.message); // Show success message
            getApplicationDocuments();
            } else {
            failed(res?.message); // Show error message
            }
        } catch (error) {
            console.error("File upload error:", error);
            failed("File upload failed.");
        }
        }
    };
    fileInput.click();
    };

    useEffect(() => {
        setCurrentPage(1);
        if (activeTab === '1') {
            setFilteredDocuments(documents.filter(doc =>
                doc?.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                doc?.documentType?.toLowerCase().includes(searchQuery.toLowerCase())
            ));
        } else {
            setFilteredReceipts(receipts.filter(rec =>
                rec?.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                (rec?.createdBy?.firstName + ' ' + rec?.createdBy?.lastName)?.toLowerCase().includes(searchQuery.toLowerCase())
            ));
        }
    }, [searchQuery, activeTab, documents, receipts]);

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const paginatedDocuments = filteredDocuments.slice(startIndex, endIndex);
    const paginatedReceipts = filteredReceipts.slice(startIndex, endIndex);

    const handlePagination = (page) => {
    setCurrentPage(page);
    };

    return (
        <>
            <div className="repository_container table_listing_color table_padding_blk">
            {isLoading ? (<Loader/>) : null}
                <div className="main_header d-flex justify-content-between align-items-center gap-3">
                    <h2 className="home-title">Repository</h2>
                    <div className="right_block">
                        <Form className="form_block">
                            <FormGroup className="spacing_three">
                                <Input
                                    id="exampleSearch"
                                    name="search"
                                    type="search"
                                    placeholder="Search"
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                />
                                {/* <i className="fa fa-search"></i> */}
                            </FormGroup>
                        </Form>
                    </div>
                </div>
                <Nav tabs className="profile_intab horizontal-scroll d-flex">
                    <NavItem>
                        <NavLink
                            className={activeTab === '1' ? 'active' : ''}
                            onClick={() => toggleTab('1')}
                        >
                            My Documents
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={activeTab === '2' ? 'active' : ''}
                            onClick={() => toggleTab('2')}
                        >
                            My Photos
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={activeTab === '3' ? 'active' : ''}
                            onClick={() => toggleTab('3')}
                        >
                            My Notices/Receipts
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                    <TabPane tabId="1">
                        <div className="table-responsive table_listing_color">
                            <table>
                                <thead>
                                    <tr className="header_table">
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Document Type
                                        </th>
                                        <th>
                                            Uploaded By
                                        </th>
                                        <th>
                                            Created Date
                                        </th>
                                        <th>
                                            Download
                                        </th>
                                        <th>
                                            Upload
                                        </th>
                                        <th>
                                            Expiration
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedDocuments.length > 0 ? (
                                        paginatedDocuments.map((doc, index) => {
                                            // Get the expiration date and compare it with the current date
                                            const expirationDate = new Date(doc?.expirationDate);
                                            const currentDate = new Date();
                                            const isExpired = expirationDate < currentDate;

                                            return (
                                                <React.Fragment key={index}>
                                                    <tr className="first_block">
                                                        <td className="name_block">{doc?.title}</td>
                                                        <td>{doc?.documentTypeDetails?.documentTitle || "Unknown"}</td>
                                                        <td>{doc?.uploadedBy?.firstName + " " + doc?.uploadedBy?.lastName || "Unknown"}</td>
                                                        <td>{moment(doc?.uploadDate).format("YYYY-MM-DD") || "Not Available"}</td>
                                                        <td className="text-center">
                                                            <span className="material-symbols-outlined" onClick={()=>handleDownload(doc?.filePath?.publicUrl)}>
                                                                download
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span className="material-symbols-outlined" onClick={()=>handleDocumentUpload(doc?._id)}>
                                                                upload
                                                            </span>
                                                        </td>
                                                        <td className={`expiry_status ${isExpired ? 'expired' : 'valid'}`}>
                                                            {isExpired ? 'Expired' : 'Valid'}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={9}>
                                                <p className="text-center">No Data Found</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <CustomPagination
                                totalPages={Math.ceil(documents?.length / ITEMS_PER_PAGE)}
                                totalRows={documents?.length}
                                rowsPerPage={ITEMS_PER_PAGE}
                                page={currentPage}
                                handlePage={handlePagination}
                            />
                        </div>
                    </TabPane>
                    <TabPane tabId="2">
                    <div className="table-responsive table_listing_color">
                            <table>
                                <thead>
                                    <tr className="header_table">
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Document Type
                                        </th>
                                        <th>
                                            Uploaded By
                                        </th>
                                        <th>
                                            Created Date
                                        </th>
                                        <th>
                                            Download
                                        </th>
                                        <th>
                                            Upload
                                        </th>
                                        <th>
                                            Expiration
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedDocuments.length > 0 ? (
                                        paginatedDocuments.map((doc, index) => {
                                            // Get the expiration date and compare it with the current date
                                            const expirationDate = new Date(doc?.expirationDate);
                                            const currentDate = new Date();
                                            const isExpired = expirationDate < currentDate;

                                            return (
                                                <React.Fragment key={index}>
                                                    <tr className="first_block">
                                                        <td className="name_block">{doc?.title}</td>
                                                        <td>{doc?.documentTypeDetails?.documentTitle || "Unknown"}</td>
                                                        <td>{doc?.uploadedBy?.firstName + " " + doc?.uploadedBy?.lastName || "Unknown"}</td>
                                                        <td>{moment(doc?.uploadDate).format("YYYY-MM-DD") || "Not Available"}</td>
                                                        <td className="text-center">
                                                            <span className="material-symbols-outlined" onClick={()=>handleDownload(doc?.filePath?.publicUrl)}>
                                                                download
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span className="material-symbols-outlined" onClick={()=>handleDocumentUpload(doc?._id)}>
                                                                upload
                                                            </span>
                                                        </td>
                                                        <td className={`expiry_status ${isExpired ? 'expired' : 'valid'}`}>
                                                            {isExpired ? 'Expired' : 'Valid'}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={9}>
                                                <p className="text-center">No Data Found</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </TabPane>
                    <TabPane tabId="3">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr className="header_table">
                                        <th>
                                            Name
                                        </th>
                                        <th>
                                            Uploaded By
                                        </th>
                                        <th>
                                            Created Date
                                        </th>
                                        <th>
                                            Download
                                        </th>
                                        <th>
                                            Upload
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedReceipts.length > 0 ? (
                                        paginatedReceipts.map((rec, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr className="first_block">
                                                        <td className="name_block">{rec?.title}</td>
                                                        <td>{rec?.uploadedBy?.name || "Unknown"}</td>
                                                        <td>{moment(rec?.uploadDate).format("YYYY-MM-DD") || "Not Available"}</td>
                                                        <td className="text-center">
                                                            <span className="material-symbols-outlined" onClick={()=>handleDownload(rec?.receiptFile?.signedUrl)}>
                                                                download
                                                            </span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span className="material-symbols-outlined" onClick={()=>handleReceiptUpload(rec)}>
                                                                upload
                                                            </span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colSpan={9} height={5} className="bg_light"></td>
                                                    </tr>
                                                </React.Fragment>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={9}>
                                                <p className="text-center">No Data Found</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className='d-flex justify-content-center'>
                            <CustomPagination
                                totalPages={Math.ceil(receipts?.length / ITEMS_PER_PAGE)}
                                totalRows={receipts?.length}
                                rowsPerPage={ITEMS_PER_PAGE}
                                page={currentPage}
                                handlePage={handlePagination}
                            />
                        </div>
                    </TabPane>
                </TabContent>
            </div>
        </>
    );
}

export default Repository;
